/**
 * Default processing message for info snackkbars
 */
export const PROCESSING_REQUEST_MESSAGE =
  'We received your request and will notify you when the processing is complete.';
